import { TeamPostInfo } from "@pallet/features/PostType/TeamPostInfo"
import { Box, Text, theme } from "@pallet-hq/hegel"
import { MiniTeamProfilePostSectionFragment } from "__generated__/MiniTeamProfilePostSectionFragment"

const PostSection = ({
    postConnection,
}: {
    postConnection: MiniTeamProfilePostSectionFragment
}) => {
    if (!postConnection.totalCount) return <></>
    return (
        <Box
            display="flex"
            flexDirection="column"
            gridGap="xsmall"
            p="xsmall"
            backgroundColor="gray200"
            borderRadius="12px"
        >
            <Text variant="uiTiny500" color="gray600" textTransform="uppercase">
                looking for
            </Text>
            {postConnection.edges.map(post => {
                return (
                    <Box
                        key={post.node.id}
                        p="12px"
                        backgroundColor="white"
                        border={`1px solid ${theme.colors.gray300}`}
                        borderRadius="12px"
                    >
                        <TeamPostInfo post={post.node} size="compact" />
                    </Box>
                )
            })}
        </Box>
    )
}

export { PostSection }
